<template>
  <v-form>
    <v-container>
      <v-row> <br /></v-row>
      <v-row>
        <v-spacer></v-spacer>

        <v-col>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <i-text-field
                v-model="date2"
                label="Date (read only text field)"
                hint="YYYY/MM format"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                outlined
              ></i-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              type="month"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col>
          <i-text-field
            dark
            success
            label="label"
            type="date"
            day-format="yyyymm"
            counter=""
            maxlength="10"
            outlined
            hint="hint"
            clearable
          ></i-text-field>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
export default {
  data: vm => ({
    date: new Date().toISOString().substr(0, 7),
    date2: new Date().toISOString().substr(0, 7),
    dateFormatted: vm.parseDate(new Date().toISOString().substr(0, 7)),
    menu2: false,
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date2() {},
    date() {
      this.dateFormatted = this.parseDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month] = date.split('-');
      return `${year}-${month}`;
    },
    parseDate(date) {
      if (!date) return null;
      console.log(date);
      const [year, month] = date.split('-');
      //return `${year}-${month.padStart(2, '0')}`;
      return `${year}${month}`;
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
</style>
